import Navbar from "@/components/navbar";
import Footer from "@/components/footer";
import { Button } from "@/components/ui/button";
import { Star, Sparkles, Trophy } from "lucide-react";

const VIDEO_TESTIMONIALS = [
  {
    id: 4,
    embedUrl: "https://www.youtube.com/embed/6PYV61Z9qmg",
    testId: "video-testimonial-4",
  },
  {
    id: 5,
    embedUrl: "https://www.youtube.com/embed/knPsHKafnbc",
    testId: "video-testimonial-5",
  },
  {
    id: 1,
    embedUrl: "https://www.youtube.com/embed/kRcY0AEWBxs",
    testId: "video-testimonial-1",
  },
  {
    id: 2,
    embedUrl: "https://www.youtube.com/embed/gQuygXx1MA8",
    testId: "video-testimonial-2",
  },
  {
    id: 3,
    embedUrl: "https://www.youtube.com/embed/JHTxSlFdJwM",
    testId: "video-testimonial-3",
  },
] as const;

export default function Testimonials() {
  const handleJoinWinners = () => {
    window.location.href = "/auth?tab=signup";
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-white">
      <Navbar />

      <main className="pb-20">
        <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-800 text-white py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur px-4 py-1 rounded-full text-sm font-medium mb-6">
              <Sparkles className="h-4 w-4 text-yellow-300" />
              Real Winners • Real Drops
            </div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Testimonials from the Prize Drop Community
            </h1>
            <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto mb-8">
              Real stories from Prize Drop winners across South Africa.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                size="lg"
                className="bg-white text-blue-900 hover:bg-blue-50 font-semibold px-8"
                onClick={handleJoinWinners}
              >
                <Trophy className="mr-2 h-5 w-5" />
                Join & Stand a Chance to Win
              </Button>
            </div>
          </div>
        </section>

        <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">What Our Winners Say</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {VIDEO_TESTIMONIALS.map((video) => (
              <article
                key={video.id}
                className="bg-white rounded-2xl shadow-lg border border-slate-100 overflow-hidden flex flex-col"
              >
                <div className="aspect-[9/16] bg-black">
                  <iframe
                    src={video.embedUrl}
                    title="Winner Testimonial"
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                    data-testid={video.testId}
                  ></iframe>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center justify-center gap-1 mb-4">
                    {[...Array(5)].map((_, index) => (
                      <Star key={index} className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                  <p className="text-gray-700 mt-2 text-center font-medium">
                    Winner Testimonial
                  </p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
          <div className="bg-blue-900 rounded-3xl text-white p-10 text-center shadow-2xl">
            <p className="text-lg md:text-xl mb-6">
              Ready to join them? Create your free account, earn entries, and stand a chance to win the next drop.
            </p>
            <Button
              size="lg"
              variant="secondary"
              className="bg-white text-blue-900 hover:bg-blue-50 font-semibold px-10"
              onClick={handleJoinWinners}
            >
              Join & Stand a Chance to Win
            </Button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
